// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"467e0343","29":"ce9dc137","36":"6e57767b","55":"4f7dbe77","61":"71b245a8","68":"5c4fc21f","194":"f20611ae","251":"dacdd61a","378":"155915cd","453":"41435cd6","570":"ed3334fa","701":"b088a558","727":"884b43b4","849":"70a1034f","931":"bb3b59ba","994":"db2f745e"}[chunkId] + ".chunk.js";
};